import { getAuthHeaders } from '../../utils/token';
import { api } from '../Users/user';

const BASE_URL = api + '/api/settings';

// --- Tipos para Configuración ---

export interface SettingsAPI {
  _id: string;
  institution_name: string;
  logo_primary_base64?: string;
  logo_secondary_base64?: string;
  primary_logo_filename?: string;
  secondary_logo_filename?: string;
  createdAt: string;
  updatedAt: string;
}

export interface SettingsData {
  institution_name?: string;
  logo_primary_base64?: string;
  logo_secondary_base64?: string;
  primary_logo_filename?: string;
  secondary_logo_filename?: string;
}

// --- Función de Utilidad para Fetch con Manejo de Errores (Reutilizada) ---
async function apiFetch<T>(url: string, options: RequestInit): Promise<T> {
  const defaultHeaders = getAuthHeaders();
  options.headers = {
    ...defaultHeaders,
    'Content-Type': 'application/json',
    ...options.headers,
  };

  const response = await fetch(url, options);
  const data = await response
    .json()
    .catch(() => ({ message: response.statusText || 'Error desconocido' }));

  if (!response.ok) {
    throw new Error(data.message || `La petición falló con status ${response.status}`);
  }

  return data as T;
}

/**
 * Obtiene la configuración global de la institución.
 */
export function fetchSettings(): Promise<SettingsAPI> {
  return apiFetch<SettingsAPI>(BASE_URL, { method: 'GET' });
}

/**
 * Actualiza la configuración global.
 */
export function updateSettings(data: SettingsData): Promise<SettingsAPI> {
  // Usamos PATCH según la ruta definida
  return apiFetch<SettingsAPI>(BASE_URL, { method: 'PATCH', body: JSON.stringify(data) });
}
